export default __webpack_public_path__ + "86b69324a3a9778df62fe6453f3e07b7.gif";